import React, { useEffect } from 'react';
import Icon from '../../common/components/IconSvg/Icon';
import './GeneralError.scss';

interface GeneralErrorProps {
  title: string;
  message?: string | React.ReactNode;
  icon: string;
}

function GeneralError({ title, message, icon }: GeneralErrorProps) {
  return (
    <div className="general-error" data-testid="general-error-message">
      <Icon name={icon} style={{ width: 192, height: 192 }} />
      <div className="general-error__title">{title}</div>
      <div className="general-error__message">{message}</div>
    </div>
  );
}

export default GeneralError;
